import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({ className, type, focused, ...props }: React.ComponentProps<'input'> & { focused?: boolean }) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-border flex h-9 w-full min-w-0 rounded-sm border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        'h-[42px] bg-[#F3F6FA] placeholder-[#474C5E]',
        'focus-visible:border-border focus-visible:ring-border focus-visible:ring-[2px]',
        {
          'border-border ring-border ring-[2px]': focused,
        },
        className,
      )}
      {...props}
    />
  );
}

export { Input };
